import { reactive, toRefs } from '@vue/composition-api';
import { acceptResult, getQrcode, scanResult } from '@api/controll'

const errorMessage = {
    timeout: '二维码过期',
    fail: '二维码失效，请刷新',
    abandon: '已取消',
    accept: '验证成功',
    scanned: '扫码成功，请在手机上确认',
};

export const useQrcode = (props: {
    qrType: string;
    serviceOwnParams: Record<string, any>;
    onOk: (token: string) => void;
}) => {
    const state = reactive<{
        qrCodeUrl: string;
        qrStatus: 'fail' | 'timeout' | 'accept' | 'scanned' | 'abandon' | '';
        statusMessage: string;
    }>({
        qrCodeUrl: '',
        qrStatus: '',
        statusMessage: '',
    });
    function cancelScan() {
        try {
            (scanResult as any).cancel();
            (scanResult as any).hasCancel = true;
        } catch (e) {
            // console.log(e);
        }
    }
    async function refresh() {
        state.qrCodeUrl = '';
        state.qrStatus = '';
        state.statusMessage = '';
        try {
            const qrStart = await getQrcode(
                props.qrType,
                props.serviceOwnParams,
            );

            state.qrCodeUrl = `data:image/PNG;base64,${qrStart.imageData}`;

            const qrScan = await scanResult(
                qrStart.qrLoginToken,
                qrStart.qrLoginSignature!,
            );

            if (!qrScan) {
                state.qrStatus = 'timeout';
                state.statusMessage = errorMessage[state.qrStatus];
                return ;
            }

            state.qrStatus = 'scanned';
            state.statusMessage = Reflect.get(errorMessage, state.qrStatus);
            const qrAccept = await acceptResult(
                qrStart.qrLoginToken,
                qrScan.qrLoginSignature || qrStart.qrLoginSignature,
            );

            if (!qrAccept) {
                state.qrStatus = 'abandon';
                state.statusMessage = errorMessage[state.qrStatus];
                cancelScan();
                return;
            }

            state.qrStatus = 'accept';
            state.statusMessage = errorMessage[state.qrStatus];
            props.onOk(qrAccept.serviceOwnToken!);
        } catch (e){
            // 升级后，sdk在取消时会抛出取消的错误事件，导致业务会进入异常逻辑
            // state.qrStatus = 'fail';
            // state.statusMessage = errorMessage[state.qrStatus];
        }
    }

    return reactive({
        refresh,
        cancelScan,
        ...toRefs(state),
    });
};
